import type { Nullable } from '@src/shared/types/common';

function cbPipelineInitial_onDataBound() {
    window.cbPipelineInitial.select(0);
    window.btCreatePipelineEntity.enable(true);
}

function cbPipelineInitial_onChange() {
    if (!window.cbPipelineInitial.dataItem()) {
        window.cbPipelineInitial.select(0);
    }
}

function getInitialPipelineWindow(title: string = 'Выбор воронки') {
    let pipelineWindow = $('#pipelineWindow').data('kendoWindow');
    if (!pipelineWindow) {
        pipelineWindow = $('<div id="pipelineWindow"></div>').kendoWindow({
            ...window.kendoWindowOptions,
            pinned: true,
            width: '500px',
            title,
            scrollable: false
        }).data('kendoWindow');
    }

    return pipelineWindow;
}

function selectInitialPipeline(
    entityTypes: Array<Record<string, unknown>>,
    callBack?: (value: string) => void,
    ids: Nullable<number[]> = null
) {
    const popup = getInitialPipelineWindow();

    window.btCreatePipelineEntity_onClick = () => {
        const combo = $('#cbPipelineInitial').data('kendoComboBox');
        callBack?.(combo?.value() ?? '');
        $('#pipelineWindow').data('kendoWindow')?.close();
    };
    popup?.refresh({
        url: `/Pipeline/InitialPipeline`,
        type: 'POST',
        data: {
            entityTypes: Array.isArray(entityTypes) ? entityTypes : [entityTypes],
            ids: ids
        }
    });
    popup?.center();
    popup?.open();
}

function setComboBoxBackColor(combo: kendo.ui.ComboBox, color: string) {
    if (color) {
        combo.wrapper.find('.k-input-inner').css('background', `#${color}`);
    }
}

function pipelineStatus_onDataBound(e: kendo.ui.ComboBoxDataBoundEvent) {
    const combo = e.sender;
    const dataItem = combo.dataItem();

    if (dataItem) {
        setComboBoxBackColor(combo, dataItem);
    }
}

function ihaspipelinedict_pipelineStatus_onDataBound(e: kendo.ui.ComboBoxDataBoundEvent) {
    const cbStatus = e.sender;
    setTimeout(() => {
        const dataItem = cbStatus.dataItem();
        if (dataItem?.Color) {
            setComboBoxBackColor(cbStatus, dataItem.Color);
        }
    }, 500);
    const data = ihaspipelinedict_getDataForStatusChange(e);
    window.ihaspipelinedict_entityType = data['EntityType'];
    window.ihaspipelinedict_entityId = data['Id'];
}

function ihaspipelinedict_btVisualizationModeonClick() {
    if (window.ihaspipelinedict_traceWindow.options.visible) {
        window.ihaspipelinedict_traceWindow.close();
    }
    else {
        window.rebindDataSource(window.ihaspipelinedict_grPipelineTraces);
        window.ihaspipelinedict_traceWindow.center().open();
    }
}

function ihaspipelinedict_grPipelineTraces_onRequestEnd(e: kendo.data.DataSourceRequestEndEvent) {
    window.backDataSource_onRequestEnd(e, window.ihaspipelinedict_grPipelineTraces);
}

function ihaspipelinedict_cbStatus_onChange(this: kendo.ui.ComboBox, e: kendo.ui.ComboBoxEvent) {
    const data = ihaspipelinedict_getDataForStatusChange(e);
    const statusChangeEventData = {
        OldStatusId: window.ihaspipelinedict_cbStatus_value,
        NewStatusId: this.value()
    };

    ihaspieplinedict_changeStatus(data, e, statusChangeEventData);
}

function ihaspieplinedict_changeStatus(
    data: ReturnType<typeof ihaspipelinedict_getDataForStatusChange>,
    e: kendo.ui.ComboBoxEvent,
    statusChangeEventData: {
        NewStatusId: Nullable<string>;
        OldStatusId: Nullable<string>;
    }
) {
    e.sender.close();
    e.sender.enable(false);

    if (data['StatusId']) {
        window.ajaxPost(
            '/PipelineStatus/UpdateEntityStatus',
            data,
            (response: { Message?: string }) => {
                if (response.Message) {
                    window.swal.fire('Внимание!', response.Message, 'warning');
                    e.sender.value(window.ihaspipelinedict_cbStatus_value ?? '');
                    e.preventDefault();
                }
                else {
                    window.ihaspipelinedict_cbStatus_value = statusChangeEventData.NewStatusId;
                    setTimeout(() => {
                        window.rebindDataSource(e.sender);
                    }, 500);
                    setTimeout(() => {
                        window.rebindDataSource(window.ihaspipelinedict_grPipelineTraces);
                    }, 5000);
                }

                e.sender.enable(true);
            }
        );
    }
}

/**
 * TODO: выделить отдельную задачу и пересмотреть решение, т.к. тут что то странно происходит
 * Продебажить и определить почему такая длинная цепочка из `.parent`
 * */
function ihaspipelinedict_getDataForStatusChange({ sender }: kendo.ui.ComboBoxEvent) {
    const parentElement = sender.element.parent().parent().parent();
    const wrapper = parentElement.get(0);

    return {
        'Id': Number(wrapper?.querySelector<HTMLInputElement>('#Id')?.value),
        'StatusId': Number(sender.value()),
        'EntityType': Number(wrapper?.querySelector<HTMLInputElement>('#EntityType')?.value)
    };
}

window.getInitialPipelineWindow = getInitialPipelineWindow;
window.cbPipelineInitial_onChange = cbPipelineInitial_onChange;
window.ihaspipelinedict_btVisualizationModeonClick = ihaspipelinedict_btVisualizationModeonClick;
window.ihaspipelinedict_cbStatus_onChange = ihaspipelinedict_cbStatus_onChange;
window.ihaspipelinedict_getDataForStatusChange = ihaspipelinedict_getDataForStatusChange;
window.ihaspipelinedict_grPipelineTraces_onRequestEnd = ihaspipelinedict_grPipelineTraces_onRequestEnd;
window.ihaspipelinedict_pipelineStatus_onDataBound = ihaspipelinedict_pipelineStatus_onDataBound;
window.pipelineStatus_onDataBound = pipelineStatus_onDataBound;
window.selectInitialPipeline = selectInitialPipeline;
window.setComboBoxBackColor = setComboBoxBackColor;
window.cbPipelineInitial_onDataBound = cbPipelineInitial_onDataBound;
